import { IoClose } from "react-icons/io5";
import { LiaEdit } from "react-icons/lia";
import WinHistory from "../Components/WinHistory";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { Profiles } from "../Components/Yup";
import { baseUrl } from "../constant";
import axios from "axios";
import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Notiflix from "notiflix";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import serviceFunctions from "../Services";
import { useCallback } from "react";

export default function Profile() {
  const [base64Image, setBase64Image] = useState("");
  const [userData, setUserdata] = useState({});
  const [currentSubscription, setCurrentSubscription] = useState(null);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleShow = () => {
    setShow(true);
  };

  const handleImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/gif",
      ];
      const maxSize = 300 * 1024; // 300KB

      // Type validation
      if (!allowedTypes.includes(file.type)) {
        toast.error("Only image files (JPG, PNG, GIF) are allowed.");
        setBase64Image(null);
        return;
      }

      // Size validation
      if (file.size > maxSize) {
        toast.error("Image is too large. Maximum allowed size is 300KB.");
        setBase64Image(null);
        return;
      }

      // Convert to base64
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  let token = localStorage.getItem("token");
  const navigate = useNavigate();

  const fetchUserData = useCallback(async () => {
    try {
      Notiflix.Loading.circle();
      const response = await axios.get(`${baseUrl}/user/get-user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data?.status === "success") {
        const user = response.data.data.user;
        setUserdata(user);
        setCurrentSubscription(response.data.data.current_subscription || null);
        localStorage.setItem("mobile", user.mobile_number);
        localStorage.setItem("network", user.network);
      } else {
        toast.error(response.data?.message || "Unable to load user data.");
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        serviceFunctions.handleLogout();
      } else {
        console.error(error);
      }
    } finally {
      Notiflix.Loading.remove();
    }
  }, [token]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchUserData();
    }, 10);

    return () => clearTimeout(timeoutId);
  }, [fetchUserData, show]);

  const formInitialValues = {
    user_name: userData?.user_name || "", // safe fallback
  };

  const formik = useFormik({
    initialValues: formInitialValues,
    enableReinitialize: true,
    validationSchema: Profiles,
    onSubmit: async (values) => {
      console.log("Form Submitted", values);
      setLoading(true);
      Notiflix.Loading.circle();
      try {
        const response = await axios.post(
          `${baseUrl}/user/update-profile`,
          {
            user_name: values.user_name,
            image: base64Image,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        Notiflix.Loading.remove();

        if (response.data.status === "success") {
          toast.success(response.data.message, { duration: 3000 });
          setShow(false);
        } else {
          toast.error(response.data.message, { duration: 4000 });
        }
      } catch (error) {
        Notiflix.Loading.remove();

        if (error?.response?.statusCode === 401) {
          serviceFunctions.handleLogout();
        }

        toast.error("An error occurred. Please try again.", {
          duration: 4000,
        });
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const logoutSession = () => {
    serviceFunctions.handleLogout();
  };

  const unsubscribe = async () => {
    const serviceId = currentSubscription?.service_id;
    const trxn_id = currentSubscription?.trxn_id;

    if (!serviceId) {
      toast.error("No active subscription to unsubscribe.");
      return;
    }

    try {
      Notiflix.Loading.circle();
      const response = await axios.post(
        `${baseUrl}/subscription/unsubscribe`,
        { service_id: serviceId, trxn_id: trxn_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200 && response.data?.success) {
        toast.success(response.data.message, { duration: 3000 });
        await fetchUserData();
      } else {
        toast.info(response.data?.message || "Unable to unsubscribe.", {
          duration: 3000,
        });
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        serviceFunctions.handleLogout();
      }

      toast.error(
        err?.response?.data?.message || err.message || "Unable to unsubscribe.",
        { duration: 3000 }
      );
    } finally {
      Notiflix.Loading.remove();
    }
  };

  return (
    <>
      <div className="profilePage">
        <div className="d-flex justify-content-between ">
          <IoClose className="close" onClick={() => navigate(-1)} />
          <p onClick={logoutSession} className="m-0 logout">
            Logout
          </p>
        </div>

        <div className="mt-2 title d-flex justify-content-between">
          <p>Profile</p>
          <p onClick={() => navigate("/help")} className="profilehelp">
            Help
          </p>
        </div>
        <div className="info">
          <div className="information text-center">
            <img
              src={userData.avatar ? userData.avatar : "images/avatar.png"}
              alt=""
            />
            <div className="d-flex align-items-center justify-content-center userinfo">
              <p className="m-0 pe-1">{userData ? userData.user_name : ""}</p>
              <LiaEdit onClick={handleShow} />
            </div>
            <p className="m-0 userNum">{userData.mobile_number}</p>
            {currentSubscription?.pack_name && (
              <div className="subscription-details mt-2">
                <p className="m-0  f-2 subscription-pack" style={{ fontSize: "12px", }}>
                  Subscribed Pack : {currentSubscription.pack_name}
                </p>
                <a
                  href="#!"
                  className="unsubscribe-link"
                  onClick={(e) => {
                    e.preventDefault();
                    unsubscribe();
                  }}
                  style={{ fontSize: "12px", color: "red", textDecoration: "underline" }}
                >
                  Unsubscribe
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="histroy">
          <p className="my-3 title">Winning History</p>
          <WinHistory />
        </div>
      </div>

      <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={formik.handleSubmit} autoComplete="off">
            <div className="mb-3">
              <label className="col-form-label">user_name</label>
              <input
                className="form-control"
                type="text"
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
                value={formik.values.user_name}
                id="user_name"
                name="user_name"
                placeholder="Enter User name"
                required
              />
            </div>
            {formik.errors.user_name && formik.touched.user_name ? (
              <span style={{ color: "red" }}>{formik.errors.user_name}</span>
            ) : null}

            <div className="mb-3">
              <label htmlFor="formFile" className="form-label">
                Upload Image
              </label>
              <input
                className="form-control"
                type="file"
                id="formFile"
                name="myImage"
                onChange={handleImage}
                accept="image/*" // Only allow image file types in picker
              />
            </div>

            <button
              className="btn btn-info mt-2"
              type="submit"
              name="submit"
              disabled={loading || !base64Image} // Disable if no valid image
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </form>
        </Modal.Body>
      </Modal>

      <ToastContainer />
    </>
  );
}
